"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LABEL_TYPE = void 0;
exports.LABEL_TYPE = {
    PROMO: 'promo',
    ACTIVE: 'active',
    INACTIVE: 'inactive',
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error',
};
//# sourceMappingURL=enums.js.map